/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ImpersonationStatusDto } from '../models';
// @ts-ignore
import type { StartImpersonationDto } from '../models';
/**
 * AdminImpersonationApi - axios parameter creator
 * @export
 */
export const AdminImpersonationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns whether the current session is impersonating another user and who.
         * @summary Get current impersonation status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImpersonationStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/impersonation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Switches the effective session user to the given target. Requires the real (authenticated) admin to hold the ADMIN_IMPERSONATE permission. The Keycloak session and SecurityContext are not changed; only the effective application user is overridden for the session. 
         * @summary Start impersonating a user
         * @param {StartImpersonationDto} startImpersonationDto Target user to impersonate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImpersonation: async (startImpersonationDto: StartImpersonationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'startImpersonationDto' is not null or undefined
            assertParamExists('startImpersonation', 'startImpersonationDto', startImpersonationDto)
            const localVarPath = `/api/v1/admin/impersonation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startImpersonationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clears any active impersonation and restores the real admin session.
         * @summary Stop impersonating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopImpersonation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/impersonation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminImpersonationApi - functional programming interface
 * @export
 */
export const AdminImpersonationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminImpersonationApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns whether the current session is impersonating another user and who.
         * @summary Get current impersonation status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImpersonationStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImpersonationStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImpersonationStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminImpersonationApi.getImpersonationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Switches the effective session user to the given target. Requires the real (authenticated) admin to hold the ADMIN_IMPERSONATE permission. The Keycloak session and SecurityContext are not changed; only the effective application user is overridden for the session. 
         * @summary Start impersonating a user
         * @param {StartImpersonationDto} startImpersonationDto Target user to impersonate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startImpersonation(startImpersonationDto: StartImpersonationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImpersonationStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startImpersonation(startImpersonationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminImpersonationApi.startImpersonation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clears any active impersonation and restores the real admin session.
         * @summary Stop impersonating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopImpersonation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImpersonationStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopImpersonation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminImpersonationApi.stopImpersonation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminImpersonationApi - factory interface
 * @export
 */
export const AdminImpersonationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminImpersonationApiFp(configuration)
    return {
        /**
         * Returns whether the current session is impersonating another user and who.
         * @summary Get current impersonation status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImpersonationStatus(options?: RawAxiosRequestConfig): AxiosPromise<ImpersonationStatusDto> {
            return localVarFp.getImpersonationStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Switches the effective session user to the given target. Requires the real (authenticated) admin to hold the ADMIN_IMPERSONATE permission. The Keycloak session and SecurityContext are not changed; only the effective application user is overridden for the session. 
         * @summary Start impersonating a user
         * @param {StartImpersonationDto} startImpersonationDto Target user to impersonate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImpersonation(startImpersonationDto: StartImpersonationDto, options?: RawAxiosRequestConfig): AxiosPromise<ImpersonationStatusDto> {
            return localVarFp.startImpersonation(startImpersonationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Clears any active impersonation and restores the real admin session.
         * @summary Stop impersonating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopImpersonation(options?: RawAxiosRequestConfig): AxiosPromise<ImpersonationStatusDto> {
            return localVarFp.stopImpersonation(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminImpersonationApi - interface
 * @export
 * @interface AdminImpersonationApi
 */
export interface AdminImpersonationApiInterface {
    /**
     * Returns whether the current session is impersonating another user and who.
     * @summary Get current impersonation status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImpersonationApiInterface
     */
    getImpersonationStatus(options?: RawAxiosRequestConfig): AxiosPromise<ImpersonationStatusDto>;

    /**
     * Switches the effective session user to the given target. Requires the real (authenticated) admin to hold the ADMIN_IMPERSONATE permission. The Keycloak session and SecurityContext are not changed; only the effective application user is overridden for the session. 
     * @summary Start impersonating a user
     * @param {StartImpersonationDto} startImpersonationDto Target user to impersonate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImpersonationApiInterface
     */
    startImpersonation(startImpersonationDto: StartImpersonationDto, options?: RawAxiosRequestConfig): AxiosPromise<ImpersonationStatusDto>;

    /**
     * Clears any active impersonation and restores the real admin session.
     * @summary Stop impersonating
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImpersonationApiInterface
     */
    stopImpersonation(options?: RawAxiosRequestConfig): AxiosPromise<ImpersonationStatusDto>;

}

/**
 * AdminImpersonationApi - object-oriented interface
 * @export
 * @class AdminImpersonationApi
 * @extends {BaseAPI}
 */
export class AdminImpersonationApi extends BaseAPI implements AdminImpersonationApiInterface {
    /**
     * Returns whether the current session is impersonating another user and who.
     * @summary Get current impersonation status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImpersonationApi
     */
    public getImpersonationStatus(options?: RawAxiosRequestConfig) {
        return AdminImpersonationApiFp(this.configuration).getImpersonationStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Switches the effective session user to the given target. Requires the real (authenticated) admin to hold the ADMIN_IMPERSONATE permission. The Keycloak session and SecurityContext are not changed; only the effective application user is overridden for the session. 
     * @summary Start impersonating a user
     * @param {StartImpersonationDto} startImpersonationDto Target user to impersonate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImpersonationApi
     */
    public startImpersonation(startImpersonationDto: StartImpersonationDto, options?: RawAxiosRequestConfig) {
        return AdminImpersonationApiFp(this.configuration).startImpersonation(startImpersonationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clears any active impersonation and restores the real admin session.
     * @summary Stop impersonating
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImpersonationApi
     */
    public stopImpersonation(options?: RawAxiosRequestConfig) {
        return AdminImpersonationApiFp(this.configuration).stopImpersonation(options).then((request) => request(this.axios, this.basePath));
    }
}

